import React from 'react';
import { apiGetDevice, apiSetPrevPageDetails, apiTrackPage } from "../api";
import { 
    GET_DEVICE_DATA, GET_DEVICE_DATA_FAILED,
    PREV_PAGE_DATA, PREV_PAGE_DATA_FAILED,
    TRACK_PAGE, TRACK_PAGE_FAILED
} from "../actions";

export const trackPage = (data) => async dispatch => {
    try {
        const response = await apiTrackPage(data); 

        dispatch({
            type: TRACK_PAGE,
            payload: response
        });
    } catch (e) {
        dispatch({
            type: TRACK_PAGE_FAILED,
            payload: e
        });
    }
}

export const getDeviceData = async dispatch => {
    try {
        let data = await apiGetDevice();
        dispatch({
            type: GET_DEVICE_DATA,
            payload: data
        });
    } catch (e) {
        dispatch({
            type: GET_DEVICE_DATA_FAILED,
            payload: e
        });
    }
}

export const setPrevPageDetails = (data) => async dispatch => {
    try {
        const response = await apiSetPrevPageDetails(data);
        dispatch({
            type: PREV_PAGE_DATA,
            payload: response
        });
    } catch (e) {
        dispatch({
            type: PREV_PAGE_DATA_FAILED,
            payload: e
        });
    }
}